import TemplateApi from 'api/activityTemplateApi';
import { timelineToTemplate } from 'selectors/timeline';
import { message } from 'antd';
import { TEMPLATE_TIMELINE } from './actionTypes';

const actionType = TEMPLATE_TIMELINE;

// ========================================
// TEMPLATE TIMELINE
// ========================================

export const requestInFlight = () => ({
  type: actionType.REQUEST_IN_FLIGHT
});

export const newTemplateTimeline = () => ({
  type: actionType.NEW_TEMPLATE
});

const loadTemplateTimelineSuccess = data => ({
  type: actionType.LOADED_TEMPLATE_SUCCESS,
  data
});
const loadTemplateTimelineFailure = data => ({
  type: actionType.LOADED_TEMPLATE_FAILURE,
  data
});

export const loadTemplateTimeline = id => (dispatch) => {
  dispatch(requestInFlight());
  return TemplateApi.getActivityTemplate({ id })
    .then(
      (response) => {
        const itemData = JSON.parse(JSON.stringify(response.data));
        dispatch(loadTemplateTimelineSuccess(itemData));
        return itemData;
      },
      (error) => {
        dispatch(loadTemplateTimelineFailure(error));
        throw error;
      }
    );
};

const saveTemplateTimelineSuccess = template => ({
  type: actionType.SAVE_TEMPLATE_SUCCESS,
  data: template
});
const saveTemplateTimelineFailure = template => ({
  type: actionType.SAVE_TEMPLATE_FAILURE,
  data: template
});

export const saveTemplateTimeline = (templateId, activities) => (dispatch) => {
  dispatch(requestInFlight());
  return TemplateApi.saveActivityTemplateActivities(templateId, timelineToTemplate(activities))
    .then(
      (response) => {
        if (response.status === 207) {
          message.warning(response.data);
        }
        // Dispatch a successful save
        const itemData = response.data;
        dispatch(saveTemplateTimelineSuccess(itemData));

        // Reload the template
        dispatch(loadTemplateTimeline(templateId));
        return itemData;
      },
      (error) => {
        dispatch(saveTemplateTimelineFailure(error));
        throw error;
      }
    );
};

// ========================================
// TEMPLATE TIMELINE ACTIVITIES
// ========================================

export const addTimelineActivity = (activity, group, time, createActivityCount = 1, hoursBetween = 24) => ({
  type: actionType.ADD_ACTIVITY_TO_TIMELINE,
  activity,
  group,
  time,
  createActivityCount,
  hoursBetween
});

// @param {*} changes EG: "{"isStartTimeChange":false,"timeDelta":0}"
// @param {*} items
// @param {*} maxTimelineDays
//
export const updateTimelineActivities = items => ({
  type: actionType.UPDATE_ACTIVITIES,
  items
});

export const deleteTimelineActivity = () => ({
  type: actionType.DELETE_TIMELINE_ACTIVITY
});

export const selectTimelineActivities = itemIds => ({
  type: actionType.SELECT_TIMELINE_ACTIVITIES,
  ids: itemIds
});

// @param {*} changes EG: "{"rowChangeDelta":0,"timeDelta":150}" //min
// @param {*} items EG: "[{"title":"Crew Roster","key":1349,"row":1,"start":"2001-01-03T23:00:00.000Z","end":"2001-01-04T11:00:00.000Z","color":"#4a90e2"},{"title":"Crew Roster","key":1350,"row":1,"start":"2001-01-04T23:00:00.000Z","end":"2001-01-05T11:00:00.000Z","color":"#4a90e2"}]"
// @param {*} maxTimelineDays
//
export const moveTimelineActivities = (changes, items) => ({
  type: actionType.MOVE_ACTIVITIES,
  changes,
  items
});

// @param {*} changes EG: "{"isStartTimeChange":false,"timeDelta":0}"
// @param {*} items
// @param {*} maxTimelineDays
//
export const resizeTimelineActivities = (changes, items) => ({
  type: actionType.RESIZE_ACTIVITIES,
  changes,
  items
});

export const updatePinnedActivities = activities => ({
  type: actionType.UPDATE_PINNED_ACTIVITIES,
  activities
});

export const reorderTimelineGroup = (fromGroupId, toGroupId) => ({
  type: actionType.REORDER_GROUP,
  fromGroupId,
  toGroupId
});

export const deleteTimelineGroup = groupId => ({
  type: actionType.DELETE_ENTIRE_GROUP,
  groupId
});
